export default __webpack_public_path__ + "static/media/KFOkCnqEu92Fr1Mu51xEIzIXKMnyrYk.023fd1d9.woff2";